import { message } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  Settings,
  SettingsResponseType,
} from 'utils/apiClient/services/shorepay/types';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../utils/apiClient';

function checkTypeSettingsOrError(
  data: SettingsResponseType
): data is Settings {
  if ((data as Settings).business_profile) {
    return true;
  }
  return false;
}

export const useSaveSettings = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.ShorePay.postSettings,
    onSettled: (data: SettingsResponseType) => {
      if (checkTypeSettingsOrError(data)) {
        message.success(
          intl.formatMessage({ defaultMessage: 'Changes saved successfully' })
        );
      } else {
        handleErrorNotification({
          error: data?.message,
          lang: intl.locale.toLowerCase(),
        });
      }
    },
  });
};

export const useStripeDashboardLink = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['shorepay', 'stripelink'],
    queryFn: apiClient.ShorePay.fetchDashboardLink,
    retry: false,
    staleTime: 1000,
  });
};
